import React from 'react';
import './LogoutConfirmationModal.css';

const LogoutConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="logout-modal-overlay">
      <div className="logout-modal">
        <div className='logout-modal-label'>로그아웃 하시겠습니까?</div>
        <div className="logout-modal-buttons">
          <button className="logout-cancel-button" onClick={onClose}>아니요</button>
          <button className="logout-confirm-button" onClick={onConfirm}>네 로그아웃할게요</button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationModal;
